export default __webpack_public_path__ + "static/media/VA.be3e8f88.svg";